// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"23":"fc85de2e","54":"0e9a6bfc","64":"e7cc91d7","138":"339c5e94","182":"07ece654","298":"60be0065","496":"c53690f0","563":"c117dfd5","630":"7fc6e3a5","667":"d63c7531","669":"22ce8fa2","942":"b210a4d9"}[chunkId] + ".js";
};